import {Formik, Form} from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../components/formikControl/FormikControl'
import toast from 'react-hot-toast'
import {createShift, updateShift} from './api'
import {handleApiError} from '../../../helpers/errorHandler'
import FormResetBtn from '../../../components/FormResetBtn'
import FormSubmitBtn from '../../../components/FormSubmitBtn'

function ShiftForm({initialValues, onAfterSubmit}) {
  const formType = initialValues ? 'update' : 'add'

  const submitHandler = (values, {setSubmitting: setLoading}) => {
    setLoading(true)
    const toastId = toast.loading('Submitting')
    const action = formType === 'add' ? createShift : updateShift
    action(values)
      .then(() => {
        toast.success('Success', {id: toastId})
        onAfterSubmit()
      })
      .catch((err) => {
        handleApiError(err, toastId)
      })
      .then((res) => setLoading(false))
  }
  const formValues = initialValues || {
    shift_name: '',
    starting_time: '',
    ending_time: '',
  }
  const timeStringToMinutes = (timeString) => {
    const [hours, minutes] = timeString.split(':').map(Number)
    return hours * 60 + minutes
  }

  const isEndTimeAfterStartTime = (endTime, startTime) => {
    return timeStringToMinutes(endTime) > timeStringToMinutes(startTime)
  }
  return (
    <div className="px-5 py-3">
      <Formik
        initialValues={formValues}
        validationSchema={Yup.object({
          shift_name: Yup.string()
            .max(50, 'The Shift name cannot exceed 50 characters')
            .required('Shift Name is required')
            .notOneOf([''], 'Shift Name is Required'),
          starting_time: Yup.string()
            .required('Starting Time is required')
            .notOneOf([''], 'Starting Time is Required'),
          ending_time: Yup.string()
            .required('End Time is required')
            .notOneOf([''], 'End Time is Required')
            .test(
              'is-after-start',
              'End Time must be greater than Starting Time',
              function (value) {
                return isEndTimeAfterStartTime(value, this.parent.starting_time)
              }
            ),
        })}
        onSubmit={submitHandler}
      >
        {({isSubmitting, resetForm, dirty, isValid}) => (
          <Form>
            <FormikControl
              control="input"
              required
              placeholder="Shift Name"
              label="Shift Name"
              name="shift_name"
            />

            <FormikControl
              control="input"
              required
              placeholder="Start Time"
              label="Start Time"
              name="starting_time"
              type="time"
            />
            <FormikControl
              control="input"
              required
              placeholder="End Time"
              label="End Time"
              name="ending_time"
              type="time"
            />

            <div className="text-center pt-10">
              <FormResetBtn onClick={() => resetForm} disabled={isSubmitting} className="me-4" />

              <FormSubmitBtn disabled={!dirty || !isValid || isSubmitting} />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default ShiftForm
